import React, { useEffect, useState } from "react";
import "./Calendar.css";
import { Container, Flex, Header, SafeArea } from "../../components/layout";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../components/firebase/firebase";
import Image from "../../assets/images/calendar/calendar.webp";
import { Link } from "react-router-dom";
import { logEvent, serializeError } from "../../utils/logger";

function Calendar() {
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);

  const fetchArticles = async () => {
    try {
      let dataQuery = query(collection(db, "calendar"), orderBy("dateStart"));

      const querySnapshot = await getDocs(dataQuery);
      let fetchedData = [];

      querySnapshot.forEach((doc) => {
        fetchedData.push({ id: doc.id, ...doc.data() });
      });

      // Séparer les événements selon leur date
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Définir à minuit pour comparaison

      const upcoming = [];
      const past = [];

      fetchedData.forEach((event) => {
        if (!event.dateEnd) {
          // Si pas de date de fin, considérer comme à venir
          upcoming.push(event);
        } else {
          const endDate = new Date(event.dateEnd);
          endDate.setHours(23, 59, 59, 999); // Fin de journée

          if (endDate >= today) {
            upcoming.push(event);
          } else {
            past.push(event);
          }
        }
      });

      // Trier les événements à venir par date (les sans date à la fin)
      upcoming.sort((a, b) => {
        if (!a.dateStart) return 1;
        if (!b.dateStart) return -1;
        return new Date(a.dateStart) - new Date(b.dateStart);
      });

      // Trier les événements passés par date décroissante (plus récents en premier)
      past.sort((a, b) => {
        if (!a.dateStart) return 1;
        if (!b.dateStart) return -1;
        return new Date(b.dateStart) - new Date(a.dateStart);
      });

      setUpcomingEvents(upcoming);
      setPastEvents(past);
    } catch (error) {
      console.error("Erreur lors du chargement des articles :", error);
      logEvent("ERROR", "DB", "Failed to fetch calendar events", {
        error: serializeError(error),
        collection: "calendar",
      });
    }
  };

  useEffect(() => {
    fetchArticles();
  }, []);

  const formatDate = (dateStart, dateEnd) => {
    if (!dateStart || !dateEnd) return "À venir";

    const [yearStart, monthStart, dayStart] = dateStart.split("-");
    const [yearEnd, monthEnd, dayEnd] = dateEnd.split("-");
    const monthString = [
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre",
    ];
    return `${dayStart} ${
      monthString[monthStart - 1]
    } ${yearStart} - ${dayEnd} ${monthString[monthEnd - 1]} ${yearEnd}`;
  };

  return (
    <SafeArea className="Calendar">
      {/* Section des prochains stages */}
      <Header title="Les prochains stages" />
      <Container className="wrapper">
        <Flex type="col-center">
          <div className="wrapper">
            <div className="left">
              <img src={Image} alt="" />
            </div>
            <div className="right">
              {upcomingEvents.length > 0 ? (
                upcomingEvents.map((d, index) => (
                  <div key={index} className="container">
                    <p dangerouslySetInnerHTML={{ __html: d.title || "" }}></p>
                    <Link to={`/calendrier/flyers/${d.id}`}>
                      {formatDate(d.dateStart, d.dateEnd)}
                    </Link>
                  </div>
                ))
              ) : (
                <div className="container">
                  <p>Aucun stage prévu pour le moment</p>
                </div>
              )}
            </div>
          </div>
        </Flex>
      </Container>

      {/* Section des anciens stages */}
      {pastEvents.length > 0 && (
        <>
          <Header title="les stages passés" />
          <Container className="past-events">
            <Flex type="col-center">
              <div>
                <div className="right full-width text-center">
                  {pastEvents.map((d, index) => (
                    <div key={index} className="container past-container">
                      <p
                        dangerouslySetInnerHTML={{ __html: d.title || "" }}
                      ></p>
                      <Link to={`/calendrier/flyers/${d.id}`}>
                        {formatDate(d.dateStart, d.dateEnd)}
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </Flex>
          </Container>
        </>
      )}
    </SafeArea>
  );
}

export default Calendar;
